import hintTableFatherDlg from './src/main.js'
export default hintTableFatherDlg



// WEBPACK FOOTER //
// ./src/components/hintTableFatherDlg/index.js